import React from 'react'

import { graphql } from 'gatsby'

import type { MediaComponent, DrupalMediaBase } from './types'

export interface MediaSVGImage extends DrupalMediaBase {
	__typename: 'media__svg_image'
	field_media_image: {
		alt?: string
	}
	relationships: {
		field_media_image: {
			localFile: {
				url: string
			}
		}
	}
}

const MediaSvgImageComponent: MediaComponent<MediaSVGImage> = ({ className, media, title }) => (
	<img
		className={className}
		src={media.relationships.field_media_image.localFile.url}
		alt={media.field_media_image.alt}
		title={title}
	/>
)

export default MediaSvgImageComponent

export const query = graphql`
	fragment MediaSvgImage on media__svg_image {
		__typename
		mid: drupal_internal__mid
		field_media_image {
			alt
		}
		relationships {
			field_media_image {
				localFile {
					url
				}
			}
		}
	}
`
